import { useApiClient } from "../apiClients";
import { CHAPTERS_ENDPOINTS } from "./endpoints";
import type { Document, DocumentVersion } from "../../models/domain";
import { buildChapterImportFormData } from "../../components/documents/chapterImport";

export interface ChapterImportResponse {
  document: Document;
  version: DocumentVersion;
  /** false : même `chapter_ref` déjà présent ⇒ nouvelle version du même document. */
  created: boolean;
  lessons: number;
  passages: number;
}

/** Corps d'une 422 de l'import : le champ fautif du manifeste. */
export interface ChapterImportError {
  error: string;
  field?: string;
}

export const useChaptersApi = () => {
  const apiClient = useApiClient("embed");

  /** Import d'un chapitre : Markdown + manifeste JSON séparé (multipart). */
  const importChapter = (fields: { file: File; manifest: File; isActive: boolean }) =>
    apiClient.post<ChapterImportResponse>(
      CHAPTERS_ENDPOINTS.IMPORT,
      buildChapterImportFormData(fields),
      { headers: { "Content-Type": "multipart/form-data" } },
    );

  return { importChapter };
};
